import { atom } from "recoil"

export const migrationContactsRequestIdState = atom({
  key: "atoms/contact/migrationContactRequestIdState",
  default: 0,
})
